import type { Condition } from '@inixiative/json-rules';

// gloss
export const CURRENT_SEASON: Condition = { field: 'createdAt', dateOperator: 'within', value: { this: 'year' } };

// gloss
export const PREVIOUS_SEASON: Condition = { field: 'createdAt', dateOperator: 'within', value: { last: 'year' } };
